export default "__VITE_ASSET__BVJ220fi__"